/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Share_Card_TitleInputs */

const en_us2_workout_share_card_title = /** @type {(inputs: Workout_Share_Card_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workout done`)
};

const pt_br2_workout_share_card_title = /** @type {(inputs: Workout_Share_Card_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treino concluído`)
};

const es_419_workout_share_card_title = /** @type {(inputs: Workout_Share_Card_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrenamiento completado`)
};

const pt_pt2_workout_share_card_title = /** @type {(inputs: Workout_Share_Card_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treino concluído`)
};

const fr_fr2_workout_share_card_title = /** @type {(inputs: Workout_Share_Card_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séance terminée`)
};

const de_de2_workout_share_card_title = /** @type {(inputs: Workout_Share_Card_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training geschafft`)
};

const it_it2_workout_share_card_title = /** @type {(inputs: Workout_Share_Card_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allenamento completato`)
};

/**
* | output |
* | --- |
* | "Workout done" |
*
* @param {Workout_Share_Card_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_share_card_title = /** @type {((inputs?: Workout_Share_Card_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Share_Card_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_share_card_title(inputs)
	if (locale === "es-419") return es_419_workout_share_card_title(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_share_card_title(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_share_card_title(inputs)
	if (locale === "de-DE") return de_de2_workout_share_card_title(inputs)
	if (locale === "it-IT") return it_it2_workout_share_card_title(inputs)
	return en_us2_workout_share_card_title(inputs)
});
export { workout_share_card_title as "workout-share.card_title" }